<script lang="ts" context="module">
  export interface MatchStatisticsContext {
    largestDeal: number;
    teamRankToParticipants: Map<number, ERAR.Schema.MatchParticipation[]>;
    queueTable: Record<string, ERAR.Schema.LightQueueEntity>;
    myRank: number;
    averageRp: number;
  }
  export const matchStatisticsContext = Symbol();
</script>

<script lang="ts">
  import type { ResultOf } from '$lib/erar/api';
  import type ERAR from '$lib/erar/spec';
  import { orderBy } from '$lib/utils/array';
  import { setContext } from 'svelte';
  import MatchDetailsParticipants from './match-details-participants.svelte';
  import MatchDetailsPlayerStatistics from './match-details-player-statistics.svelte';
  import { getTeamRankToParticipants } from './utils';
  import { isNormal } from '../season/season';

  export let match: ERAR.Schema.MatchParticipation;
  export let participants: ResultOf<'GET /participants/by-match/[id]'>;
  $: queueTableValues = Object.values(participants.queueTable);
  $: averageRp = isNormal(match.seasonId)
    ? queueTableValues.reduce((sum, current) => sum + current.mmr, 0) / queueTableValues.length
    : participants.result.reduce((sum, current) => sum + current.recordedMMR, 0) /
      participants.result.length;
  $: if (isNaN(averageRp)) {
    averageRp = 0;
  }
  $: teamRankToParticipants = getTeamRankToParticipants(participants.result);
  $: largestDeal =
    participants.result.map((match) => match.totalDeal).sort(orderBy((v) => v, true))[0] ?? 0;

  $: setContext<MatchStatisticsContext>(matchStatisticsContext, {
    largestDeal,
    teamRankToParticipants,
    myRank: match.rank,
    averageRp,
    queueTable: participants.queueTable,
  });
</script>

<section class="statistics">
  <MatchDetailsPlayerStatistics {match} />
</section>
<MatchDetailsParticipants />

<style lang="postcss">
  section {
    padding: var(--space-4);
  }
</style>
